// 侧栏导航数据（PRD §4.4 页面清单）：路由 path 与 route-table.ts 路由表一一对应。
// 纯数据文件（同 market 的 features/shell/nav.ts）。
//
// 导航图标登记制（11-ui-kit §10「导航图标登记制」，LeapWorldTwin-113 接入）：推翻旧
// 「导航一律纯文字」裁决——每组内全部登记 @bf/ui 图标（同组要么全有要么全无，
// AppShell 开发态 console.warn 兜底半登记）。图标名查 tasks/LeapWorldTwin-111-workbench-ui-suite.md
// 完工报告「16 概念→图标映射」表；表外条目从 packages/ui/src/icons.tsx 既有图标里按语义就近取，
// 不新增图标定义（本单 change_paths 不含 packages/ui）。

import {
  AlertTriangle,
  ArrowLeftRight,
  BarChart3,
  BookOpen,
  CircleCheck,
  CircleHelp,
  FileText,
  Flag,
  Gauge,
  History,
  KeyRound,
  Lightbulb,
  Medal,
  Megaphone,
  MessageSquare,
  ShieldCheck,
  SlidersHorizontal,
  User,
  UserCheck,
  Users,
  WalletCards,
  type IconComponent,
} from "@bf/ui";
import { CAPABILITIES, type Capability } from "../../../shared/capabilities";

export interface NavItem {
  to: string;
  label: string;
  /** 任一能力命中即可见 */
  anyOf: Capability[];
  /** 仅精确匹配高亮（如 "/"） */
  end?: boolean;
  icon?: IconComponent;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    title: "概览",
    items: [
      { to: "/", label: "工作台", anyOf: ["employee"], end: true, icon: Gauge },
      { to: "/ranking", label: "排行榜", anyOf: ["employee"], icon: BarChart3 },
      { to: "/publicity", label: "公示", anyOf: ["employee"], icon: Megaphone },
    ],
  },
  {
    title: "申报",
    items: [
      { to: "/claims", label: "申报中心", anyOf: ["employee"], icon: FileText },
      { to: "/innovation", label: "创新成果", anyOf: ["employee"], icon: Lightbulb },
      { to: "/adhoc", label: "一事一议", anyOf: ["employee"], icon: MessageSquare },
    ],
  },
  {
    title: "渠道管理",
    items: [
      { to: "/dept-contribution", label: "部门贡献", anyOf: ["dept_head", "ops", "admin"], icon: Users },
      { to: "/projects", label: "项目积分", anyOf: ["employee"], icon: Flag },
      { to: "/contests", label: "竞赛", anyOf: ["employee"], icon: Medal },
      { to: "/honors", label: "荣誉表彰", anyOf: ["employee"], icon: ShieldCheck },
      { to: "/committee", label: "委员积分", anyOf: ["employee"], icon: UserCheck },
    ],
  },
  {
    title: "审批与运营",
    items: [
      { to: "/approvals", label: "审批中心", anyOf: ["dept_head", "ops", "decide", "review", "verify", "admin"], icon: CircleCheck },
      { to: "/booking", label: "待入账", anyOf: ["ops"], icon: BookOpen },
      { to: "/deductions", label: "违纪扣分", anyOf: ["dept_head", "ops", "decide", "verify", "admin"], icon: AlertTriangle },
      { to: "/ledger", label: "台账", anyOf: ["ops", "decide", "verify", "admin"], icon: BookOpen },
      { to: "/budget", label: "预算", anyOf: ["ops", "decide", "verify", "admin"], icon: WalletCards },
    ],
  },
  {
    title: "我的",
    items: [
      { to: "/redemptions", label: "兑换中心", anyOf: ["employee"], icon: ArrowLeftRight },
      { to: "/account", label: "个人中心", anyOf: ["employee"], icon: User },
    ],
  },
  {
    title: "工具",
    items: [{ to: "/tools/api-keys", label: "接入 Agent", anyOf: [...CAPABILITIES], icon: KeyRound }],
  },
  {
    title: "系统",
    items: [
      { to: "/admin", label: "系统管理", anyOf: ["admin"], icon: SlidersHorizontal },
      { to: "/admin/agent-logs", label: "Agent 调用日志", anyOf: ["admin"], icon: History },
    ],
  },
  {
    title: "文档",
    items: [{ to: "/help/", label: "帮助", anyOf: ["employee"], icon: CircleHelp }],
  },
];
